import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import {SetValueOptions} from 'components/hook-form/helpers';
import React from 'react';
import {useController, useFormContext} from 'react-hook-form';
import {DropdownObjectOption} from './Dropdown';

type Props = {
   name: string;
   disabled?: boolean;
   options: string[];
   labels?: {[key: string]: string};
};

export type CheckboxArrayProps = Props & {
   value: string[];
   setValue: (v: string[]) => void;
};

const CheckboxArray = ({labels, disabled, options, value, setValue}: CheckboxArrayProps) => {
   const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const {name, checked} = event.target;
      if (checked) {
         return setValue([...value, name]);
      }
      setValue(value.filter((value) => name !== value));
   };

   return (
      <FormControl component="fieldset" disabled={disabled}>
         <FormGroup>
            {options.map((opt, index) => {
               const checked = value?.includes(opt);
               return (
                  <FormControlLabel
                     key={opt}
                     label={labels ? labels[opt] : opt}
                     control={
                        <Checkbox
                           disableRipple
                           checked={checked}
                           onChange={handleChange}
                           name={opt}
                        />
                     }
                  />
               );
            })}
         </FormGroup>
      </FormControl>
   );
};

const HookCheckboxArray = (props: Props) => {
   const {
      field: {value},
   } = useController({
      name: props.name,
   });
   const methods = useFormContext();
   const setValue = React.useCallback(
      (val: any) => methods.setValue(props.name, val, SetValueOptions),
      [methods.setValue, props.name]
   );

   return <CheckboxArray value={value || []} setValue={setValue} {...props} />;
};

export default React.memo(HookCheckboxArray);
